module.exports = __webpack_public_path__ + "img/no-image.859d22d7.jpg";